// @flow
import React, { Component } from 'react';
import { loadPaymentWidget, ANONYMOUS } from "@tosspayments/payment-widget-sdk";
import Circles from 'components/common/Loaders/Circles';
import CheckoutTemplate from 'components/checkout/CheckoutTemplate';
import type { State } from 'store';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { BaseActions, CartActions, OrdersActions, UserActions } from '../../store/actionCreators';

type Props = {
  cart: any,
  user: any,
  order: any,
  logged: boolean,
  loading: boolean,
};

type CheckoutState = {
  checkoutTerms: boolean,
  checkoutPrivacy: boolean,
  checkoutAll: boolean,
  appliedCoupon: any,
  appliedDiscount: any,
  paymentMethod: any,
  addressNameFull: string,
  addressEmail: string,
  addressMobile: string,
  addressPhone: string,
  addressCity: string,
  addressState: string,
  addressAddress1: string,
  addressAddress2: string,
  addressPostCode: any,
  request: any,
};

class CheckoutTemplateContainer extends Component<Props, CheckoutState> {
  state = {
    checkoutTerms: false,
    checkoutPrivacy: false,
    checkoutAll: false,
    appliedCoupon: '',
    appliedDiscount: '',
    paymentMethod: '',
    addressNameFull: this.props.logged ? this.props.user.user.managerName : '',
    addressEmail: this.props.logged ? this.props.user.user.email : '',
    addressMobile: this.props.logged ? this.props.user.user.mobile : '',
    addressPhone: this.props.logged ? this.props.user.user.bizNumber : '',
    addressCity: '',
    addressState: '',
    addressAddress1: '',
    addressAddress2: '',
    addressPostCode: '',
    request: '',
    initLoading: true,
    paymentWidget: null,
    paymentMethodsWidget: null,
    paymentAgreement: null,
  };

  initialize = async () => {
    this.setState({ initLoading: true });
    const { history } = this.props;

    try {
      const widgetClientKey = process.env.WIDGET_CLIENT_KEY;
      const customerKey = this.props.logged ? this.props.user.user.id : ANONYMOUS;
      const paymentWidget = await loadPaymentWidget(widgetClientKey, customerKey);

      let cart = {
        items: [],
        total: {
          price: {
            sale: {
              raw: 0,
            },
            original: {
              raw: 0,
            },
          },
          items: {
            price: {
              sale: {
                raw: 0,
              },
              original: {
                raw: 0,
              }
            },
            discounted: {
              raw: 0,
            },
            taxed: {
              raw: 0,
            },
          },
          shipping: {
            fee: {
              sale: {
                raw: 0,
              },
            }
          },
          discounted: {
            raw: 0,
          },
          taxed: {
            raw: 0,
          },
          amount: {
            raw: 0,
          },
          taxes: [{
            key: "KR/VAT",
            taxed: {
              raw: 0,
            }
          }],
          paid: {
            raw: 0,
          },
          cancelled: {
            raw: 0,
          },
          refunded: {
            raw: 0,
          },
        }
      };
      let items = [];
      this.props.cart.items.filter((item) => item.checked === true).map((item) => {
        return items.push({
          ...item,
          price: {
            sale: {
              raw: item.product_price.price,
            },
            original: {
              raw: item.product_price.original_price,
            }
          },
          total: {
            price: {
              sale: {
                raw: Math.round(item.product_price.price * item.quantity),
              },
              original: {
                raw: Math.round(item.product_price.original_price * item.quantity),
              },
            },
            taxed: {
              raw: Math.round((item.product_price.price * item.quantity) * 0.1),
            },
            discounted: {
              raw: Math.round((item.product_price.original_price - item.product_price.price) * item.quantity),
            },
          },
        });
      });
      if (!items.length) history.replace('/cart');
      cart.items = items;
      cart.total.price.sale.raw = items.reduce((acc, cur) => acc + cur.total.price.sale.raw, 0);
      cart.total.price.original.raw = items.reduce((acc, cur) => acc + cur.total.price.original.raw, 0);
      cart.total.discounted.raw = items.reduce((acc, cur) => acc + cur.total.discounted.raw, 0);
      cart.total.shipping.fee.sale.raw = cart.total.price.sale.raw >= 100000 ? 0 : 3500;
      cart.total.taxed.raw = Math.round(items.reduce((acc, cur) => acc + cur.total.taxed.raw, 0) + cart.total.shipping.fee.sale.raw * 0.1);
      cart.total.amount.raw = cart.total.price.sale.raw + cart.total.shipping.fee.sale.raw + cart.total.taxed.raw;

      if (this.props.logged) {
        if (this.props.user.user.address.primary) {
          this.setState({
            addressCity: this.props.user.user.address.primary.city,
            addressState: this.props.user.user.address.primary.state,
            addressAddress1: this.props.user.user.address.primary.address1,
            addressAddress2: this.props.user.user.address.primary.address2,
            addressPostCode: this.props.user.user.address.primary.postcode,
          });
        }
        await CartActions.getCart(cart);
      } else {
        await CartActions.getAsNonRegisteredCart(cart);
      }
      this.setState({ paymentWidget, initLoading: false });
    } catch (e) {
      console.log(e);
      if (e && e.response) {
        history.replace('/cart');
      }
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.paymentWidget !== this.state.paymentWidget) {
      this.renderPaymentWidget();
    }
  }

  componentDidMount() {
    this.initialize();
  }

  renderPaymentWidget = () => {
    const { paymentWidget } = this.state;
    if (!paymentWidget) return;

    const paymentMethodsWidget = paymentWidget.renderPaymentMethods(
      "#payment-widget",
      { value: this.props.cart.total.amount.raw },
      { variantKey: "DEFAULT" }
    );

    const paymentAgreement = paymentWidget.renderAgreement(
      "#agreement",
      { variantKey: "AGREEMENT" }
    );

    this.setState({ paymentMethodsWidget, paymentAgreement });
  };

  // eslint-disable-next-line consistent-return
  onCheckOut = async () => {
    if (!this.state.addressNameFull) return alert('수취자명을 입력해야합니다.');
    if (!this.state.addressEmail) return alert('이메일을 입력해야합니다.');
    if (!this.state.addressMobile) return alert('핸드폰 번호를 입력해야합니다.');
    if (!this.state.addressPostCode) return alert('주소 찾기 버튼을 눌러 우편번호를 입력해야합니다.');
    if (!this.state.addressAddress2) return alert('상세주소를 입력해야합니다.');
    if (!this.state.checkoutTerms) return alert('이용 약관에 동의해야합니다.');
    if (!this.state.checkoutPrivacy) return alert('개인정보 수집·이용에 동의해야합니다.');

    // 토스페이 위젯 로딩 체크
    const {
      paymentWidget,
      paymentMethodsWidget,
      paymentAgreement
    } = this.state;

    if (!paymentWidget) {
      alert("결제 위젯이 로드되지 않았습니다. 다시 시도해주세요.");
      return false;
    }

    const selectedPaymentMethod = paymentMethodsWidget.getSelectedPaymentMethod();
    const isPaymentAgreement = paymentAgreement.getAgreementStatus().agreedRequiredTerms;

    if (!selectedPaymentMethod) return alert('결제 방법을 선택해주세요.');
    if (!isPaymentAgreement) return alert('결제 서비스 이용 약관을 동의해야합니다.');

    let paymentMethod = 'default';
    if (selectedPaymentMethod.type === 'NORMAL') {
      if (selectedPaymentMethod.method === '카드') {
        paymentMethod = 'iamport'
      }
      if (selectedPaymentMethod.method === '가상계좌') {
        paymentMethod = 'virtual-bank'
      }
      if (selectedPaymentMethod.method === '계좌이체') {
        paymentMethod = 'quick-bank-transfer'
      }
      if (selectedPaymentMethod.method === '간편결제') {
        if (selectedPaymentMethod.easyPay.provider === '토스페이') {
          paymentMethod = 'tosspay'
        }
        if (selectedPaymentMethod.easyPay.provider === '네이버페이') {
          paymentMethod = 'naverpay'
        }
        if (selectedPaymentMethod.easyPay.provider === '카카오페이') {
          paymentMethod = 'kakaopay'
        }
      }
    } else if (selectedPaymentMethod.type === 'KEYIN') {
      if (selectedPaymentMethod.method === '카드') {
        paymentMethod = 'research-transfer'
      }
    } else if (selectedPaymentMethod.type === 'CUSTOM') {
      if (selectedPaymentMethod.paymentMethodKey === 'bank-transfer') {
        paymentMethod = 'bank-transfer'
      }
      if (selectedPaymentMethod.paymentMethodKey === 'post-transfer') {
        paymentMethod = 'post-transfer'
      }
    }

    let address = {
      billing: {
        address1: this.state.addressAddress1,
        address2: this.state.addressAddress2,
        city: this.state.addressCity,
        country: 'KR',
        company: this.props.logged ? this.props.user.user.displayName : '',
        mobile: this.state.addressMobile,
        name: {
          first: null,
          last: null,
          full: this.state.addressNameFull,
        },
        phone: this.state.addressPhone,
        postcode: this.state.addressPostCode,
        state: this.state.addressState,
      },
      shipping: {
        address1: this.state.addressAddress1,
        address2: this.state.addressAddress2,
        city: this.state.addressCity,
        country: 'KR',
        company: this.props.logged ? this.props.user.user.displayName : '',
        mobile: this.state.addressMobile,
        name: {
          first: null,
          last: null,
          full: this.state.addressNameFull,
        },
        phone: this.state.addressPhone,
        postcode: this.state.addressPostCode,
        state: this.state.addressState,
      },
    };
    let checkoutPayload = {
      items: this.props.cart.items,
      total: this.props.cart.total,
      address,
      customer: {
        name: { full: this.state.addressNameFull },
        email: this.state.addressEmail,
        mobile: this.state.addressMobile,
        phone: this.state.addressPhone,
        company: this.props.logged ? this.props.user.user.displayName : '',
        grade: this.props.logged ? this.props.user.user.grade.name : '',
      },
      paymentMethod,
      request: this.state.request,
    };

    // 회원, 비회원 주문서 생성 분기
    if (this.props.logged) {
      await CartActions.checkoutCart(checkoutPayload);
    } else {
      await CartActions.checkoutAsNonRegisteredCart(checkoutPayload);
    }

    if (selectedPaymentMethod.type === 'CUSTOM') {
      this.props.history.push(`/checkout-success?orderId=${this.props.cart.checkout.order.id}`);
    }

    const partNumber = this.props.cart.checkout.order.items[0].product_price.part_number;
    const itemCount = this.props.cart.checkout.order.items.length - 1;
    const orderName = this.props.cart.checkout.order.items.length > 1
      ? `${partNumber} 외 ${itemCount}종`
      : partNumber;

    // 토스페이 결제 모듈
    try {
      await paymentWidget.requestPayment({
        orderId: this.props.cart.checkout.order.id,
        orderName,
        customerName: this.props.cart.checkout.order.customer.name.full,
        customerEmail: this.props.cart.checkout.order.customer.email,
        customerMobilePhone: this.props.cart.checkout.order.customer.mobile.replace(/[^0-9]/g, ""),
        successUrl: `${window.location.origin}/checkout-success`,
        failUrl: `${window.location.origin}/checkout-fail`,
      });
    } catch (error) {
      console.error("Error requesting payment:", error);
      BaseActions.showToast({
        type: 'error',
        message: error.message,
      });
      await OrdersActions.deleteOrder(this.props.cart.checkout.order.id);
    }
  };

  onCheckoutTerms = () => {
    this.setState({
      checkoutTerms: !this.state.checkoutTerms,
      checkoutAll: !this.state.checkoutTerms && this.state.checkoutPrivacy,
    });
  };

  onCheckoutPrivacy = () => {
    this.setState({
      checkoutPrivacy: !this.state.checkoutPrivacy,
      checkoutAll: !this.state.checkoutPrivacy && this.state.checkoutTerms,
    });
  };

  onCheckoutAll = () => {
    this.setState({
      checkoutTerms: !this.state.checkoutAll,
      checkoutPrivacy: !this.state.checkoutAll,
      checkoutAll: !this.state.checkoutAll,
    });
  };

  onCartCoupon = event => {
    this.setState({
      appliedCoupon: event.target.value,
    });
  };

  applyCoupons = async () => {
    const { history } = this.props;
    try {
      const items = [];
      this.props.cart.items
        .filter(item => item.checked === true)
        .map(item => {
          return items.push({
            _id: item._id,
            product: item.product._id,
            variant: item.variant._id,
            quantity: item.quantity,
            shippingMethod: item.shippingMethod._id,
            request: item.request,
            addedAt: item.addedAt.raw,
          });
        });
      // eslint-disable-next-line prefer-destructuring
      const address = this.props.user.user.address.primary;
      delete address.email;
      address.country = 'KR';
      await CartActions.getCart({
        items,
        address: {
          primary: address,
        },
        discount: {
          cart: {
            coupon: this.state.appliedCoupon,
          },
        },
      });
    } catch (e) {
      if (e && e.response) {
        history.replace('/cart');
      }
    }
  };

  applyDiscounts = async () => {
    const { history } = this.props;
    try {
      const items = [];
      this.props.cart.items
        .filter(item => item.checked === true)
        .map(item => {
          return items.push({
            _id: item._id,
            product: item.product._id,
            variant: item.variant._id,
            quantity: item.quantity,
            shippingMethod: item.shippingMethod._id,
            request: item.request,
            addedAt: item.addedAt.raw,
          });
        });
      let payload = {
        items,
      };
      if (this.state.appliedDiscount) {
        payload.discount = {
          cart: {
            discounts: [
              this.state.appliedDiscount
            ],
          },
        };
      }
      await CartActions.getAsNonRegisteredCart(payload);
    } catch (e) {
      if (e && e.response) {
        history.replace('/cart');
      }
    }
  };

  onPaymentMethod = event => {
    this.setState({
      paymentMethod: event.target.value,
    });
  };

  handleChange = (e: any) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // eslint-disable-next-line consistent-return
  onFindAddress = async () => {
    if (!this.state.addressNameFull) return alert('수취자명을 입력해야합니다.');
    if (!this.state.addressEmail) return alert('이메일을 입력해야합니다.');
    if (!this.state.addressMobile) return alert('핸드폰 번호를 입력해야합니다.');

    const themeObj = {
      searchBgColor: '#0B65C8',
      queryTextColor: '#FFFFFF',
    };

    // eslint-disable-next-line no-undef
    new daum.Postcode({
      theme: themeObj,
      oncomplete: async (data: any) => {
        // 팝업에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

        // 각 주소의 노출 규칙에 따라 주소를 조합한다.
        // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
        let addr = ''; // 주소 변수

        // 사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
        if (data.userSelectedType === 'R') {
          // 사용자가 도로명 주소를 선택했을 경우
          addr = data.roadAddress;
        } else {
          // 사용자가 지번 주소를 선택했을 경우(J)
          addr = data.jibunAddress;
        }

        const { history } = this.props;
        try {
          this.setState({
            addressAddress1: addr,
            addressAddress2: '',
            addressCity: data.sigungu,
            addressPostCode: data.zonecode,
            addressState: data.sido,
          });
        } catch (e) {
          console.log(e);
          if (e && e.response) {
            history.replace('/cart');
          }
        }
      },
    }).open();
  };

  render() {
    if (this.state.initLoading)
      return <Circles color="blue" size="medium" text="Loading..." />;

    return (
      <CheckoutTemplate
        logged={this.props.logged}
        cart={this.props.cart}
        user={this.props.user}
        onCheckOut={this.onCheckOut}
        handleChange={this.handleChange}
        checkoutTerms={this.state.checkoutTerms}
        checkoutPrivacy={this.state.checkoutPrivacy}
        checkoutAll={this.state.checkoutAll}
        onCheckoutTerms={this.onCheckoutTerms}
        onCheckoutPrivacy={this.onCheckoutPrivacy}
        onCheckoutAll={this.onCheckoutAll}
        onCartCoupon={this.onCartCoupon}
        applyCoupons={this.applyCoupons}
        applyDiscounts={this.applyDiscounts}
        onPaymentMethod={this.onPaymentMethod}
        onFindAddress={this.onFindAddress}
        addressNameFull={this.state.addressNameFull}
        addressEmail={this.state.addressEmail}
        addressMobile={this.state.addressMobile}
        addressPhone={this.state.addressPhone}
        addressState={this.state.addressState}
        addressCity={this.state.addressCity}
        addressAddress1={this.state.addressAddress1}
        addressAddress2={this.state.addressAddress2}
        addressPostCode={this.state.addressPostCode}
        appliedDiscount={this.state.appliedDiscount}
        request={this.state.request}
        isAuthenticated
      />
    );
  }
}

export default connect(
  ({ cart, user, pender }: State) => ({
    cart,
    user,
    logged: !!user.user,
    loading: pender.pending['cart/GET_CART'],
    loading1: pender.pending['cart/GET_AS_NON_REGISTERED_CART'],
  }),
  () => ({}),
)(withRouter(CheckoutTemplateContainer));



// WEBPACK FOOTER //
// ./src/containers/checkout/CheckoutTemplateContainer.js